import React, { Component } from "react";
import Product from "./Product";
import Title from "./Title";
import moment from 'moment';
import { Table, Badge} from 'reactstrap';
import styled from "styled-components";
import { ProductConsumer } from "../context";
import firebase from "./Fireb"
import {Text } from 'react-native'

export default class transactionl extends Component {
  constructor(props) {
    super(props);
    this.state = {
      History: [],
        key: '',
        pageSize: 5, // <- 2 items will be shown on single page
        pageIndex: 0,
        i:0,
        check: false
    };
    this.handleNextPageClick = this.handleNextPageClick.bind(this);
    this.handlePrevPageClick = this.handlePrevPageClick.bind(this);
  }
  handlePrevPageClick(event) {
    this.setState(prevState => ({
      pageIndex: prevState.pageIndex > 0 ? prevState.pageIndex - 1 : 0,
      i: prevState.i -1
    }));
  }

  handleNextPageClick(event) {
    this.setState(prevState => ({
      pageIndex:
        prevState.pageIndex <
        Math.ceil(prevState.History.length / prevState.pageSize)
          ? prevState.pageIndex + 1
          : prevState.pageIndex
    }));
  }




  componentDidMount() {
    const History =[];
    const ref = firebase.firestore().collection('History').where("vid", "==", firebase.auth().currentUser.uid).orderBy("createdAt", "desc");
    ref.get().then((querySnapshot => {
      querySnapshot.forEach((doc) => {
        const { text, expense, createdAt, vendor,vid,uid,name } = doc.data();
        History.push({
          key: doc.id,
          doc, // DocumentSnapshot
          text,
          expense,
          vendor,
          name,
          createdAt,
          vid,
          uid
        })})  
      this.setState({ History});
    }));
    const ref2 = firebase.firestore().collection('History').where("vid", "==", firebase.auth().currentUser.uid);
    ref2.get().then((querySnapshot => {
      querySnapshot.forEach((doc) => {
      if (doc.exists) {
        this.setState({
          check: true
        })
      } else {
        this.setState({
          check: false
        })
      }
    });
  }))
  
  }


  
  
  rendercheck() {
    if(this.state.check == true) {
    return (
      <React.Fragment>
        <ProductWrapper className="py-5">
          <div className="container">
            <Title name="Transaction" title="List" />
            <Table striped hover>
            <table class="table" >
              <thead>
                <tr class="table">
                  <th>Index</th>
                  <th>Vendor Name</th>
                  <th>Student Name</th>
                  <th>Billing</th>
                  <th>Total Expense</th>
                  <th>Craeted At</th>
                </tr>
              </thead>
              <tbody>
                {this.state.History
                .slice(
                  this.state.pageIndex * this.state.pageSize,
                  this.state.pageIndex * this.state.pageSize + this.state.pageSize
                )
                .map((History, i ) =>
                  <tr>
                  <td>{i+=1}</td>
                <td>{History.vendor}</td>
                <td>{History.name}</td>
                  <td>{History.text}</td>
                  <td>{History.expense}<Text style={{color: "green", fontWeight: "800", fontSize: 10}}>Rs.</Text></td>
                  <td>{moment(History.createdAt.toDate()).format('lll')}</td>
              
                </tr>
              )}
            </tbody>
          </table>
          </Table>
          <button  style={{padding: "5px 5px",
      backgroundImage: "linear-gradient(to left, #000428 , #004e92)",
      color: "white",
      fontSize: "14px",
      cursor: "pointer",
      padding: "10px",
      margin: "5px",
transition: "all .5s ease-in-out",
textAlign: "center"}} className="btn" onClick={event => this.handlePrevPageClick(event)}>
   <i className="fas fa-angle-double-left fa-sm pr-2		" area-hidden="true"/>
        Prev page
      </button>
      <button  style={{padding: "5px 5px",
      backgroundImage: "linear-gradient(to left, #000428 , #004e92)",
      color: "white",
      fontSize: "14px",
      cursor: "pointer",
      padding: "10px",
      margin: "5px",
transition: "all .5s ease-in-out",
textAlign: "center"}} className="btn" onClick={event => this.handleNextPageClick(event)}>
        Next page
        <i className="     fas fa-angle-double-right fa-sm pr-2	  " area-hidden="true"/>
      </button>
 
          </div>
        </ProductWrapper>
      </React.Fragment>
    );
                }
  }
  rendercheck2()
  { 
    
    if (this.state.check == false) {
   
    return(
      <div className="container">
      <Title name="You don't have" title="any transactions right now" />
      </div>
    )}
  
  }
  render() {
  
    return (
     <div>
    {this.rendercheck()}
    
    {this.rendercheck2()}
    
        </div>
    )
  }
  
}

const ProductWrapper = styled.section``;